import { Search } from "@faire/slate/components/search";
import React from "react";

import { BuilderAdditionalProps, BuilderAttributes } from "./BuilderTypes";

export const BuilderSearch = ({
  attributes,
  showClearButton = true,
  dataTestId,
  builderState,
  builderBlock,
  ...props
}: React.ComponentProps<typeof Search> &
  BuilderAdditionalProps & {
    attributes: BuilderAttributes;
    showClearButton?: boolean;
    dataTestId?: string;
  }) => {
  const {
    "builder-id": builderId,
    key,
    onClick,
    ...otherAttributes
  } = attributes;

  return (
    <Search
      {...props}
      {...otherAttributes}
      key={key}
      builder-id={builderId}
      onClear={showClearButton ? props.onClear : undefined}
      data-test-id={dataTestId}
    />
  );
};
